import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('待出库/预占库存明细'),
      "width": 800
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "flex-box mb-10",
    staticStyle: {
      "font-size": "12px",
      "flex-wrap": "wrap"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "50%",
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.t("商品编码：")) + _vm._s(_vm.data.product_sku))]), _c('span', {
    staticStyle: {
      "width": "50%",
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.t("区域仓：")) + _vm._s(_vm.data.warehouse_code) + "[" + _vm._s(_vm.data.warehouse_name) + "]")]), _vm.productQuanlity ? _c('span', {
    staticClass: "mt-10",
    staticStyle: {
      "width": "50%",
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.t("商品品质：")) + _vm._s(_vm.$util.getEnumTextByValue(_vm.orderProductQualityEnum, _vm.productQuanlity)))]) : _vm._e()]), _c('a-tabs', {
    staticClass: "mb-20",
    attrs: {
      "animated": false
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, _vm._l(_vm.filterInventoryReservedOrderTypeEnum(_vm.inventoryReservedOrderTypeEnum), function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": item.text
      }
    });
  }), 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('resize-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "bordered": ""
    },
    scopedSlots: _vm._u([{
      key: "warehouse",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(record.warehouse_code) + "[" + _vm._s(record.warehouse_name) + "] ")]);
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "product_sku"
    },
    slot: "product_sku"
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.data ? _vm.data.product_sku : '')) + " ")])])], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    },
    model: {
      value: _vm.searchData.page_index,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "page_index", $$v);
      },
      expression: "searchData.page_index"
    }
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "fbu-analyse-name": $t("\u786E\u8BA4")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('确认')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };